<template><!--首页-->
    <div>

    </div>
</template>

<script>
    export default {
        data() {
          return {}
        },
        methods: {
        },
        created() {
        }
    }
</script>

<style>

</style>
